import { useMutation, useQueryClient } from "@tanstack/react-query";
import UsersService from "../../services/usersServiceClass";
import { usePopup } from "../usePopup";
import { AxiosError } from "axios";
import { PermissionsApiErros } from "../../utils/Api/responses/responses";

const usersService = new UsersService();

const useCreateUser = () => {
    const queryClient = useQueryClient();
    const { addPopup } = usePopup();
    return useMutation(usersService.createUser, {
        onSuccess: () => {
            queryClient.invalidateQueries({
                queryKey: ["users"],
            });
            addPopup({
                title: "Usuário criado com sucesso.",
                type: "success",
                duration: "temporary",
            });
        },
        onError: (error: AxiosError<PermissionsApiErros>) => {
            addPopup({
                title: "Erro ao criar Usuário.",
                description: error.response?.data.error,
                type: "error",
                duration: "temporary",
            });
        },
    });
};
export default useCreateUser;
